import { MessagePagingParams, Page, UnreadMessageNum, UserMessage } from "@supplier/entity";
import httpRequest from "@/api/index";
import { confirmable } from "@/utils/decorator/confirmable";

const USER_MESSAGE_PATH = "/user/message";
const getUrl = (path: string, type: number) => {
    return type ? `${path}?type=${type}` : path;
};

export const userMessageService = {
    // 全部已读
    allReaded: confirmable(
        "是否已读全部消息",
        "提示",
        "已读"
    )(async (type: number) => {
        const url = getUrl(`${USER_MESSAGE_PATH}/readed-all`, type);
        await httpRequest.post(url, {});
    }),
    // 批量已读
    batchReaded: async (ids: number[], type: number) => {
        const url = getUrl(`${USER_MESSAGE_PATH}/readed`, type);
        await httpRequest.post(url, ids);
    },
    // 删除
    batchDel: confirmable("是否删除选中消息")(async (ids: number[], type: number) => {
        const url = getUrl(`${USER_MESSAGE_PATH}/batch-delete`, type);
        await httpRequest.post(url, ids);
    }),
    // 删除
    allDel: confirmable("是否删除全部消息")(async (type: number) => {
        const url = getUrl(`${USER_MESSAGE_PATH}/delete-all`, type);
        await httpRequest.post(url, {});
    }),
    // 分页查询
    paging: async (params: MessagePagingParams): Promise<Page<UserMessage>> => {
        const { data } = await httpRequest.get(`${USER_MESSAGE_PATH}/paging`, { params });
        return data;
    },
    // 获取各类型 未读消息数量
    getMsgNum: async (): Promise<UnreadMessageNum> => {
        // POST 查询允许消息刷新并发执行，不参与写请求防重。
        const { data } = await httpRequest.post(`${USER_MESSAGE_PATH}/get-unread-message`, {}, { dedupe: false });
        return data;
    },
    // 获取消息跳转实体是否存在 0 代表不存在 1 代表存在
    getMsgEntity: async (params: { id: number }): Promise<number> => {
        const { data } = await httpRequest.get(`${USER_MESSAGE_PATH}/entity/exist`, { params });
        return data;
    }
};
